document.addEventListener('DOMContentLoaded', function() {
  const toggleButtons = document.querySelectorAll('.js-interviewToggle');
  
  // Swiperインスタンスを保持するためのオブジェクト
  const swiperInstances = {};

  toggleButtons.forEach(button => {
    button.addEventListener('click', function() {
      const interviewParent = this.closest('.js-interviewParent');  // 親要素を取得
      const content = interviewParent.querySelector('.js-interviewMoreContents');
      const swiperKey = interviewParent.getAttribute('data-swiper-key');  // swiper_keyを取得

      if (content.style.maxHeight && content.style.maxHeight !== '0px') {
        // 閉じる処理
        content.style.maxHeight = '0px';  // 高さを0にする
        content.style.opacity = '0';  // 不透明度を0にする
        setTimeout(() => {
          content.style.visibility = 'hidden';  // 完全に非表示にする
          content.style.overflow = 'hidden';  // 再びoverflowをhiddenにして閉じる

          // 親要素からis-activeクラスを削除
          interviewParent.classList.remove('is-active');

          // Swiperをdestroyする
          if (swiperInstances[swiperKey]) {
            swiperInstances[swiperKey].interviewSwiper.destroy(true, true);  // インタビュースワイパーのdestroy
            swiperInstances[swiperKey].interviewImgSwiper.destroy(true, true);  // イメージスワイパーのdestroy
            delete swiperInstances[swiperKey];  // インスタンスの削除
          }

        }, 500);  // アニメーション終了後にvisibilityとoverflowをhiddenにする
      } else {
        // 開く処理
        content.style.visibility = 'visible';  // visibilityをvisibleにして表示
        content.style.opacity = '1';  // 不透明度を1にする
//        content.style.maxHeight = content.scrollHeight + 'px';  // 高さをscrollHeightに設定
content.style.maxHeight = '2000px';  // 高さをscrollHeightに設定
        content.style.overflow = 'visible';  // overflowをvisibleにする

        // 親要素にis-activeクラスを追加
        interviewParent.classList.add('is-active');

        // スクロール処理
        const offset = -150;
        const topPosition = content.getBoundingClientRect().top + window.pageYOffset + offset;
        
        window.scrollTo({
          top: topPosition,
          behavior: 'smooth'
        });

        // 既にSwiperが存在しているかチェックして、存在していなければ初期化
        if (!swiperInstances[swiperKey]) {
          const interviewSwiper = new Swiper(`.js-interviewSwiper${swiperKey}`, {
            speed: 1000,
            effect: 'fade',
            fadeEffect: {
              crossFade: true
            },
            navigation: {
              nextEl: '.js-swiper-button-next',
              prevEl: '.js-swiper-button-prev',
            },
            loop: false,
          });

          const interviewImgSwiper = new Swiper(`.js-interviewImgSwiper${swiperKey}`, {
            slidesPerView: "auto",
            spaceBetween: 20,
            centeredSlides: true,
//            centerInsufficientSlides: true,
            loop: false,
            autoHeight: true,
            breakpoints: {
              900: {
                slidesPerView: "auto",
                spaceBetween: 37,
                centeredSlides: true,
//                centerInsufficientSlides: true,
              },
            }
          });

          // Swiperの同期設定
          interviewSwiper.controller.control = interviewImgSwiper;
          interviewImgSwiper.controller.control = interviewSwiper;

          // Swiperインスタンスを保存
          swiperInstances[swiperKey] = {
            interviewSwiper: interviewSwiper,
            interviewImgSwiper: interviewImgSwiper,
          };
        }
      }
    });
  });
});


document.querySelectorAll('.js-thumbnail').forEach(thumbnail => {
  thumbnail.addEventListener('click', (e) => {
    const groupIndex = e.currentTarget.dataset.groupIndex;  // サムネイルが属するグループのindexを取得
    const thumbIndex = e.currentTarget.dataset.thumbIndex;  // サムネイルのindexを取得
    const expandedGroup = document.querySelector(`.js-expanded[data-index="${groupIndex}"]`);
    const currentExpanded = document.querySelector('.js-expanded.show');  // 現在表示されているエリア

    // 違うエリアに切り替える場合
    if (currentExpanded && currentExpanded !== expandedGroup) {
      // 現在表示されているエリアを閉じる
      currentExpanded.style.maxHeight = '0';
      currentExpanded.classList.remove('show');
      setTimeout(() => {
        currentExpanded.style.display = 'none';
      }, 500); // アニメーション終了後に非表示にする
    }

    // 新しいエリアを表示する
    if (!expandedGroup.classList.contains('show')) {
      expandedGroup.style.display = 'block'; // 表示
      setTimeout(() => {
        expandedGroup.style.maxHeight = '700px';
        expandedGroup.classList.add('show');
      }, 10); // max-heightアニメーションをトリガー
    }

    // 同じエリア内での画像切り替え
    expandedGroup.querySelectorAll('.js-expanded-img').forEach(img => {
      img.classList.remove('active');
      img.style.opacity = '0'; // すべて非表示にする
    });

    // クリックされたサムネイルに対応する画像を表示
    const activeImage = expandedGroup.querySelector(`.js-expanded-img-${thumbIndex}`);
    activeImage.style.display = 'block'; // まず表示
    setTimeout(() => {
      activeImage.style.opacity = '1';  // 次にopacityをアニメーション
      activeImage.classList.add('active');
    }, 10);

    // 展開アニメーションが終わってからスクロール
    setTimeout(() => {
      activeImage.scrollIntoView({
        behavior: 'smooth',  // スムーズにスクロール
        block: 'center'      // 画像が画面の中央に来るように
      });
    }, 400); // max-heightアニメーションが終わった後にスクロール
  });
});




document.addEventListener('DOMContentLoaded', function() {
  // Swiperを初期化する
  const swipers = [];
  const swiperElements = document.querySelectorAll('.js-topSwiper');

  swiperElements.forEach((swiperElement, index) => {
    const swiper = new Swiper(swiperElement, {
      loop: true,
      effect: 'fade', // クロスフェードを有効にする
      fadeEffect: {
        crossFade: true, // クロスフェードを設定
      },
      speed: 3000, // スライド切り替え速度を2秒に設定
      autoplay: {
        delay: 4000, // 3秒ごとにスライド
        disableOnInteraction: false
      },
      slidesPerView: 1,
    });

    // 最初は一旦autoplayを止める
    swiper.autoplay.stop();

    // 各Swiperのautoplayを開始するタイミングをずらす
    const delayStart = 1000 * (index + 1); // 1つ目は0.5秒、2つ目は1秒の遅延

    setTimeout(() => {
      swiper.autoplay.start(); // autoplayを再開
    }, delayStart); // タイミングをずらして再開

    // Swiperを配列に保存して後で使う
    swipers.push(swiper);
  });
});
